import { useField, useFormikContext } from 'formik';
import React from 'react';
import { Input } from 'ui-components/dist/Input';
import { AvatarWithUpload } from '~/screens/AddTalent/ProfileInformation/AvatarWithUpload';

import { ProfileFormValues } from './types';

export const ProfileNameAndAvatar: React.FC = () => {
  const { values } = useFormikContext<ProfileFormValues>();
  const [, , helpers] = useField('avatar');

  const handleAvatarChange = (newAvatar: string | Blob) => {
    helpers.setValue(newAvatar);
  };

  return (
    <div className="flex items-center gap-6">
      <AvatarWithUpload
        pic={values.avatar as string}
        trackId="foam-profile-settings--avatar-upload"
        onChange={handleAvatarChange}
      />

      <Input
        isRequired
        label="First Name"
        name="firstName"
        type="text"
        className="flex-1"
        testId="creator-profile-first-name"
        trackId="foam-profile-settings--first-name"
        clearButtonProps={{
          trackId: 'foam-profile-settings--first-name-clear',
          'aria-label': 'Clear first name',
        }}
      />
      <Input
        label="Last Name"
        type="text"
        name="lastName"
        className="flex-1"
        testId="creator-profile-last-name"
        trackId="foam-profile-settings--last-name"
        clearButtonProps={{
          trackId: 'foam-profile-settings--last-name-clear',
          'aria-label': 'Clear last name',
        }}
      />
    </div>
  );
};
